export const getTransitAnalytics = (data) => {
  const total = data.length;
  const today = new Date().toISOString().split("T")[0];
  const todayDispatched = data.filter((item) => {
    const dispatchedDate = item.dispatched_date.split("T")[0];

    return dispatchedDate === today;
  }).length;

  return { total, todayDispatched };
};
